import { Button, Grid, TextField } from '@mui/material';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomAccordion from '../CustomAccordion/CustomAccordion';
import TagsFilter from '../TagFilter/TagsFilter';
import BaseResponse from '../../app/BaseResponse';
import Utility from '../../app/utility';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import SavedSearch, { ComponentType } from '../SavedSearch/SavedSearch';
import Swal from 'sweetalert2';
import { savedSearchSelector } from '../SavedSearch/reducers/SavedSearchReducer';
import { BrokerAccountInputSelector } from './reducers/BrokerAccountInputReducer';
import { QueryItem } from '../Tonnage/models/TonnageQueryModel';
import BrokerAccountApi, { SearchBrokerAccountParam } from './api/BrokerAccountApi';
import BrokerAccountModel from './models/BrokerAccountModel';
import { BrokerAccountSearchSelector, resetBrokerAccountSearch, setAccountTypes, setBrokerAccountSearchResults, setBrokers, setContactAccountNames, setContactNames, setContactSearchKeyword, setMicNames, setSearchResultTotalRecord, setStartedDateFrom, setStartedDateTo,setExpiredDateFrom, setExpiredDateTo, setTriggerBrokerAccountSearch, setTriggerFocusCompanyName } from './reducers/BrokerAccountSearchReducer';
import { searchContactName } from '../ContactSelector/ContactSelector';
import { contactInputSelector } from '../Contact/reducers/ContactInputReducer';
import { userSelectorSelector } from '../UserSelector/reducers/UserSelectorReducer';
import StartEndDatepicker from '../StartEndDatepicker/StartEndDatepicker';

const BrokerAccountSearch: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const brokerAccountSearchData = useSelector(BrokerAccountSearchSelector);
    const savedSearchData = useSelector(savedSearchSelector);
    const BrokerAccountInputViewData = useSelector(BrokerAccountInputSelector);
    const contactInputViewData = useSelector(contactInputSelector);
    const [inactiveDates, setInactiveDates] = useState<string[]>([]);
    const userSelectorData = useSelector(userSelectorSelector);

    useEffect(() => {
        setInactiveDates([
            "15 days",
            "30 days",
            "45 days",
            "60 days",
            "75 days",
            "90 days",
        ])
    }, []);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (brokerAccountSearchData.contactSearchKeyword && brokerAccountSearchData.contactSearchKeyword.length > 0) {
                searchContactName(brokerAccountSearchData.contactSearchKeyword, (contacts) => {
                    if (contacts && contacts.length > 0) {
                        dispatch(setContactAccountNames(contacts));
                    } else {
                        dispatch(setContactAccountNames([]));
                    }
                })
            }
        }, 300);
        return () => clearTimeout(timeoutId);
    }, [brokerAccountSearchData.contactSearchKeyword])

    
    const saveSavedSearch = () => {
        Swal.fire({
            title: 'Provide Saved Search Name',
            input: 'text',
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Sumbit',
            showLoaderOnConfirm: true,
            allowOutsideClick: false,
            confirmButtonColor: '#1976d2',
            preConfirm: (name) => {
                if (!name || name.length === 0) {
                    Swal.showValidationMessage("Name ")
                }
            },
        }).then((result) => {
            if (result.isConfirmed) {
                
            }
        })
    }

    useEffect(() => {
        if (brokerAccountSearchData.triggerSearch === 0) {
            return;
        }

        dispatch(showLoading(true));

        BrokerAccountApi.Search({
            query: brokerAccountSearchData.query
        } as SearchBrokerAccountParam)
            .then((response: BaseResponse<BrokerAccountModel[]>) => {
                if (response.success) {
                    dispatch(setBrokerAccountSearchResults(response.data));
                    dispatch(setSearchResultTotalRecord(response.totalRecord));
                } else {
                    Utility.Alert.Error(response.message);
                }
            }).catch((error) => {
                Utility.Alert.Error(error);
            })
            .finally(() => {
                dispatch(showLoading(false));
            });
    }, [brokerAccountSearchData.triggerSearch])

    const getTonnageSearchClass = () => {
        let className = "nice-scroll ";
        if (savedSearchData.expanded) {
            className += "tonnage-search-wrapper";
        } else {
            className += "tonnage-search-wrapper-saved-search-hide";
        }

        return className;
    }

    return (
        <>
            <SavedSearch
                component={ComponentType.BrokerAccount}
            >
            </SavedSearch>
            <CustomAccordion
                title="Search"
                defaultOpen={true}
                contentClassName={getTonnageSearchClass()}>
                <div className='tonnage-search-body'>
                    <Grid container>
                        <Grid item xs={8}>
                            <Grid container>
                                <Grid xs={8}>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        className="tonnage-search-save-button"
                                        onClick={() => {
                                            dispatch(setTriggerBrokerAccountSearch((new Date()).getTime()));
                                        }}
                                    >
                                        RUN SEARCH
                                    </Button>
                                </Grid>
                                <Grid xs={4}>
                                    <Button
                                        className="clear-input-button"
                                        color="success"
                                        variant="contained"
                                        onClick={() => {
                                            dispatch(resetBrokerAccountSearch());
                                            dispatch(setTriggerFocusCompanyName(new Date().getTime()));
                                        }}
                                    >
                                        <i className="fa fa-refresh" aria-hidden="true"></i>
                                    </Button>
                                </Grid>
                            </Grid>

                        </Grid>
                        <Grid item xs={4}>
                            <Button
                                fullWidth
                                variant="outlined"
                                onClick={() => {
                                    saveSavedSearch();
                                }}
                            >
                                Save Search
                            </Button>
                        </Grid>
                    </Grid>
                    <TagsFilter
                        data={_.map(brokerAccountSearchData.contactAccountNames, (item) => {
                            return {
                                id: item.id,
                                value: item.companyName,
                                positive: true
                            } as QueryItem
                        })}
                        useFreeText={true}
                        label="Company Name"
                        onInputChange={(text: string) => {
                            dispatch(setContactSearchKeyword(text));
                        }}
                        className="tonnage-search-item"
                        value={brokerAccountSearchData.query.contactNames}
                        onValueChange={(value: QueryItem[]) => {
                            dispatch(setContactNames(value));
                        }}
                        triggerFocusInput={brokerAccountSearchData.triggerFocusCompanyName}
                    ></TagsFilter>
                    <TagsFilter
                        data={[]}
                        useFreeText={true}
                        label="Sub Acct"
                        className="tonnage-search-item"
                        value={brokerAccountSearchData.query.micNames}
                        onValueChange={(value: QueryItem[]) => {
                            dispatch(setMicNames(value));
                        }}
                    ></TagsFilter>
                    <TagsFilter
                        data={_.map(contactInputViewData.staticResources.accountTypes, (item) => {
                            return {
                                id: item,
                                value: item,
                                positive: true
                            } as QueryItem
                        })}
                        label="Company Type"
                        className="tonnage-search-item"
                        value={brokerAccountSearchData.query.accountTypes}
                        onValueChange={(value: QueryItem[]) => {
                            dispatch(setAccountTypes(value));
                        }}
                    ></TagsFilter>
                    <TagsFilter
                        data={_.map(userSelectorData.userDisplayNames, (item) => {
                            return {
                                id: item.id.toString(),
                                value: item.displayName,
                                positive: true
                            } as QueryItem
                        })}
                        useFreeText={true}
                        label="Broker"
                        className="tonnage-search-item"
                        value={brokerAccountSearchData.query.brokers}
                        onValueChange={(value: QueryItem[]) => {
                            dispatch(setBrokers(value))
                        }}
                    ></TagsFilter>
                    <StartEndDatepicker
                        startDateLabel="Started Date From"
                        endDateLabel="Started Date To"
                        className="tonnage-search-item"
                        useQuickEndDateInput={true}
                        onStartDateChange={(date: string) => {
                            dispatch(setStartedDateFrom(date));
                        }}
                        onEndDateChange={(date: string) => {
                            dispatch(setStartedDateTo(date));
                        }}
                        startDateValue={brokerAccountSearchData.query.StartedDateFrom}
                        endDateValue={brokerAccountSearchData.query.StartedDateTo}
                    >
                    </StartEndDatepicker>
                    <StartEndDatepicker
                        startDateLabel="Expired Date From"
                        endDateLabel="Expired Date To"
                        className="tonnage-search-item"
                        useQuickEndDateInput={true}
                        onStartDateChange={(date: string) => {
                            dispatch(setExpiredDateFrom(date));
                        }}
                        onEndDateChange={(date: string) => {
                            dispatch(setExpiredDateTo(date));
                        }}
                        startDateValue={brokerAccountSearchData.query.StartedDateFrom}
                        endDateValue={brokerAccountSearchData.query.StartedDateTo}
                    >
                    </StartEndDatepicker>
                </div>
            </CustomAccordion>
        </>
    )
};

export default BrokerAccountSearch;